module.exports = __webpack_public_path__ + "img/type--4-spans--single-lang--es.bfbe6cd3.jpg";